import Vue from 'vue'
import Router from 'vue-router'
import signIn from '@/pages/login/wxLogin.vue'
import adminLogin from '@/pages/login/adminLogin.vue'
import home from '@/pages/home/index.vue'
import noFound from '@/pages/404/404.vue'

Vue.use(Router)

export default new Router({
  // mode: "history",
  routes: [
    {
      path: '/',
      redirect: '/signIn'
    },
    {
      path: '/signIn',
      name: 'signIn',
      component: signIn
    },
    {
      path: '/syzh_admin_login',
      name: 'admin_login_sy',
      component: adminLogin
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/404',
      name: 'noFound',
      component: noFound
    },
    {
      path: '*',
      redirect: '/404'
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js